var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.level)?_c('div',{staticClass:"password-input"},[_c('div',{staticClass:"strong-level",class:_vm.clazz},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"separation-one"}),_c('div',{staticClass:"separation-two"}),_c('div',{staticClass:"separation-three"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.levelText))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }